import styled from 'styled-components'

import { TitleSection as TitleSectionBase } from '@src/Application/Interfaces/Organisms/TitleSection'

export const TitleSection = styled(TitleSectionBase)`
    max-width: 970px;
    margin: 0 auto;
`
